<template>
    <div>
        <div class="contents">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="breadcrumb-main user-member justify-content-sm-between ">
                            <div class=" d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                                <div
                                    class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                    <h4 class="text-capitalize fw-500 breadcrumb-title">Edit Group Greeter</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div  class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30"> 
                            <form v-on:submit.prevent="editGroupGreeter">
                                <label>Nama Group Greeter</label>
                                <input type="text" class="form-control" v-model="form.name" autofocus required />
                                <br />
                                <label>Device</label>
                                <multiselect v-model="form.device" tag-placeholder="Pilih Device Pengirim"
                                    placeholder="Pilih Device Pengirim" label="name" :custom-label="customLabel"
                                    track-by="id" :options="device">
                                </multiselect>
                                <br />
                                <label>Pilih Group</label>
                                <br>
                                <div v-if="!isGroupLoaded">
                                    <button v-if="loading.isGroupLoading" class="btn btn-primary btn-sm" disabled>
                                        <div class="spinner-border spinner" role="status"></div>
                                        Loading...
                                    </button>
                                    <button v-else type="button" v-on:click="loadGroup(form.device)"
                                        class="btn btn-primary btn-sm">Load
                                        Group</button>
                                </div>
                                <div v-else>
                                    <multiselect v-model="form.groups" tag-placeholder="Cari group"
                                        placeholder="Cari group" label="name" track-by="id" :options="deviceGroups"
                                        :multiple="true">
                                        <template slot="beforeList">
                                            <div>
                                                <label @click="selectNoneGrup" class="selectAll">Deselect All</label>
                                                <label @click="selectAllGrup" class="selectAll">Select All</label>
                                            </div>
                                        </template>
                                    </multiselect>
                                </div>


                                <br />
                                <label>Message</label>
                                <CustomTextArea v-model="form.message"></CustomTextArea>
                                <p class="mt-2">Anda bisa menggunakan <code>[[NAME]]</code> untuk menyebut nama anggota yang bergabung ke grup</p>


                                <div class="button-group d-flex pt-25">
                                    <button type="submit"
                                        class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block">
                                        simpan
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CustomTextArea from "@/components/module/CustomTextarea.vue";
    import Multiselect from 'vue-multiselect'

    export default {
        components: {
            CustomTextArea,
            Multiselect
        },
        data() {
            return {
                device: [],
                deviceGroups: [],
                form: {
                    device: "",
                    name: "",
                    groups: [],
                    message: ""
                },
                loading: {
                    isGroupLoading: false
                },
                isGroupLoaded: false
            };
        },
        async mounted() {
            await this.getDevice()
            await this.getGroupGreeter()
        },
        watch: {
            'form.device': {
                handler() {
                    this.deviceGroups = []
                    this.isGroupLoaded = false
                },
                deep: true
            },
        },
        methods: {
            customLabel({
                name,
                status
            }) {
                return `${name} (${status})`
            },
            selectNoneGrup() {
                this.form.groups = [];
                this.$refs.selectedItemsGrup.deactivate();
            },
            selectAllGrup() {
                this.form.groups = this.deviceGroups
                this.$refs.selectedItemsGrup.deactivate();
            },
            async getDevice() {
                let response = await this.$store.dispatch('device_list')
                this.device = response.data.data.devices
            },
            async getGroupGreeter() {
                let id = this.$route.query.id
                let response = await this.$store.dispatch('group_greeter_detail', id)
                let groupGreeter = response.data.data.group_greeter
                this.form.name = groupGreeter.name
                // this.form.groups = groupGreeter.groups.map(group => this.deviceGroups.find(deviceGroup => deviceGroup.id == group.id))
                this.form.message = groupGreeter.message
                this.form.device = await this.device.find(device => device.id == groupGreeter.device_id)
                await this.loadGroup(this.form.device)

                let groupJID = groupGreeter.group.map(group => group.split(":")[1])
                this.form.groups = this.deviceGroups.filter(group => groupJID.includes(group.id))
                // this.form = groupGreeter
            },
            async loadGroup(device) {
                if (this.form.device == "") {
                    this.$toast.error("Pilih Device Terlebih Dahulu")
                    return
                }


                this.loading.isGroupLoading = true
                try {
                    this.deviceGroups = []
                    let res = await this.$store.dispatch("contact_load_group_device", {
                        id: parseInt(device.id)
                    });

                    this.deviceGroups = res.data.data.groups
                    for (let i = 0; i < this.deviceGroups.length; i++) {
                        this.deviceGroups[i].name = this.deviceGroups[i].name + " (" + this.deviceGroups[i].id + ")"
                    }
                    this.$toast.success("Load Group Sukses")

                    this.isGroupLoaded = true
                } catch (err) {
                    this.$toast.error("Load Group Gagal")
                }
                this.loading.isGroupLoading = false
            },
            async editGroupGreeter() {
                try {
                    let data = {
                        id: this.$route.query.id,
                        name: this.form.name,
                        device: this.form.device.id,
                        groups: this.form.groups.map(group => group.name.split(" ")?.[0] + ":" + group.id),
                        groups_jid: this.form.groups.map(group => group.id),
                        message: this.form.message
                    }

                    let response = await this.$store.dispatch('group_greeter_update', data)
                    this.$toast.success(response.data.message);
                    this.$router.push('/group-greeter')
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
            }
        },
    };
</script>

<style scoped>
    .thick-border {
        border-width: 2px;
        border-style: solid;
        border-color: #6b7280;
        /* Tailwind: gray-500 */
    }

    .selectAll {
        margin-right: 0.25rem;
        /* Tailwind: mr-1 */
        border: 1px solid #d1d5db;
        /* Tailwind: border-gray-300 */
        padding: 0.25rem 0.5rem;
        /* Tailwind: px-2 py-1 */
        border-radius: 0.375rem;
        /* Tailwind: rounded-md */
        background-color: white;
        color: #374151;
        /* Tailwind: text-gray-700 */
        font-size: 0.875rem;
        /* Tailwind: text-sm */
        transition: background-color 0.2s, color 0.2s;
        /* Tailwind: transition-colors duration-200 */
    }

    .selectAll:hover {
        background-color: #10b981;
        /* Tailwind: bg-emerald-500 */
        color: white;
    }
</style>